






















import { Component, Prop, Vue } from 'vue-property-decorator'
import Modal from '@/components/Modal.vue'

@Component({
	components: {
		Modal,
	},
})
export default class Confirm extends Vue {
	@Prop({ default: 'danger' }) public color!: string
	private value: boolean = false
	private title = 'Confirm Action.'
	private resolve!: any
	private reject!: any

	get headerColor() {
		return `bg-${this.color}`
	}
	get buttonColor() {
		return `btn-${this.color}`
	}

	public create(title: string) {
		this.title = title
		this.value = true
		return new Promise((resolve, reject) => {
			this.resolve = resolve
			this.reject = reject
		})
	}

	private confirm() {
		this.resolve()
		this.value = false
	}

	private rejectConfirm() {
		this.reject()
		this.value = false
	}
}
